var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layoutFooter"},[_vm._v(" Copyright © 2023-2033  jinli.  All Rights Reserved 粤ICP备2024209091号-1 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }